import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';

@Injectable()
export class ToastData {

	toast:any;

	constructor(private toastCtrl: ToastController) {
	}

	presentMessage(message) {
		if (!this.toast || !this.toast.instance) {
                this.toast = this.toastCtrl.create({
                    message: message,
                    duration: 90000,
                    position: 'bottom',
                    showCloseButton: true,
                    closeButtonText: 'Close'
                });
                this.toast.present();
            }
            this.toast.data.message = message;
	}

	clearMessage() {
		if (this.toast){
			this.toast.dismiss();
		}
	}

}


// WEBPACK FOOTER //
// ./src/providers/toast-data.ts